import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';

const prod = new Environment({
    name: stages.PRODUCTION,
    evaluationFn: (_attributes) => {
        return 'off';
    },
});

const demo = new Environment({
    ...prod,
    name: stages.DEMO,
});

const staging = new Environment({
    name: stages.STAGING,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const can_access_schedule_automatch_dev_tools = new MockSplit({
    name: 'can_access_schedule_automatch_dev_tools',
    environments: [local, dev, staging, demo, prod],
});

export default can_access_schedule_automatch_dev_tools;
